import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

import EyeIcon from "@krea/customer-features/images/svg/eye.svg";
import TrashsIcon from "@krea/customer-features/images/svg/trash.svg";
import FileSection from "@krea/customer-features/shared-components/fields/file-section";
import FileSectionAction from "@krea/customer-features/shared-components/fields/file-section/FileSectionAction";

import ExpandAnimation from "../../animations/Expand";

import styles from "./FileItem.module.scss";
import FilePreview from "./FilePreview";

const FileItem = ({ file, deleteFile, isPreviewMode }) => {
  const { t } = useTranslation();

  const onOpenFile = () => {
    window.open(file.url, "_blank");
  };

  const onDeleteFile = () => {
    deleteFile(file.file_id);
  };

  return (
    <ExpandAnimation>
      {isPreviewMode ? (
        <FilePreview title={file.original_file_name} />
      ) : (
        <Fragment>
          <FileSection
            title={file.original_file_name}
            actions={
              <Fragment>
                <FileSectionAction
                  title={t("commons.viewFile")}
                  icon={EyeIcon}
                  iconClassName={styles.openFile}
                  onClick={onOpenFile}
                />
                <FileSectionAction
                  title={t("commons.delete")}
                  icon={TrashsIcon}
                  onClick={onDeleteFile}
                />
              </Fragment>
            }
          />
        </Fragment>
      )}
    </ExpandAnimation>
  );
};

export default FileItem;
